export default __webpack_public_path__ + "static/mayo31-f6079226778ea82abb3c5a64c658501e.png";